/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type DayTimeSlotInput = {
    date: string;
    timeSlot: TimeSlot;
};
export type CalendarProfileRendererQueryVariables = {
    orgRelayId: string;
    calendarId: string;
    calendarIds: Array<string | null>;
    timeZone: string;
    rangeMin: DayTimeSlotInput;
    rangeMax: DayTimeSlotInput;
    showWeekInReview: boolean;
    week: string;
};
export type CalendarProfileRendererQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly " $fragmentRefs": FragmentRefs<"CalendarProfile_org">;
    } | null;
};
export type CalendarProfileRendererQuery = {
    readonly response: CalendarProfileRendererQueryResponse;
    readonly variables: CalendarProfileRendererQueryVariables;
};



/*
query CalendarProfileRendererQuery(
  $orgRelayId: ID!
  $calendarId: String!
  $calendarIds: [String]!
  $timeZone: String!
  $rangeMin: DayTimeSlotInput!
  $rangeMax: DayTimeSlotInput!
  $showWeekInReview: Boolean!
  $week: String!
) {
  node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      ...CalendarProfile_org_3kPRlL
    }
  }
}

fragment CalendarProfile_org_3kPRlL on Org {
  id
  experiments
  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        isUser
        userId
        ...WeekInReviewNotAvailable_person
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  ...ProfileTimeVisualizations_org_2vYicO
  ...ProfileCollaborators_orgRefetch_3nh1j1
  ...ProfileCollaborators_org_2vYicO
  rewindHistoryErrorable(calendarId: $calendarId, week: $week) @include(if: $showWeekInReview) {
    __typename
    ... on GraphEntityError {
      message
      statusCode
    }
    ... on RewindHistory {
      ...WeekInReviewScrubber_rewindHistory
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  ...WeekInReviewNotAvailable_org
}

fragment ProfileCollaborators_orgRefetch_3nh1j1 on Org {
  id
  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
    __typename
    ... on PersonList {
      list {
        id
        primaryEmail
        profile {
          givenName
          familyName
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment ProfileCollaborators_org_2vYicO on Org {
  id
  collaboratorStatsErrorable(calendarId: $calendarId, timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax) {
    __typename
    ... on GraphEntityError {
      statusCode
    }
    ... on CollaboratorStats {
      calendarId
      topCollaborators {
        calendarId
        sharedMinutes
      }
    }
  }
}

fragment ProfileTimeVisualizations_org_2vYicO on Org {
  calendarTimeStats(calendarId: $calendarId, timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax) {
    calendarId
    focusMinutes
    busyMinutes
    fragmentedMinutes
    unclassifiedMinutes
    totalMinutes
    scoresByDay {
      calendarId
      secondaryKey
      busyMinutes
      focusMinutes
      totalMinutes
    }
  }
  userWorkingHours {
    workingHours {
      daySettings {
        day
      }
      id
    }
    id
  }
}

fragment WeekInReviewNotAvailable_org on Org {
  id
}

fragment WeekInReviewNotAvailable_person on Person {
  id
  emails
  primaryEmail
  profile {
    givenName
    familyName
    externalImageUrl
  }
  isYou
  isUser
  userId
}

fragment WeekInReviewScrubber_rewindHistory on RewindHistory {
  id
  snapshotDurationMillis
  snapshots {
    snapshotMillis
    days {
      workingHours {
        amBits
        pmBits
      }
      meetings {
        amBits
        pmBits
      }
      focusTime {
        amBits
        pmBits
      }
      lunch {
        amBits
        pmBits
      }
      fragmented {
        amBits
        pmBits
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rangeMax"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rangeMin"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showWeekInReview"
    } as any, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "week"
    } as any, v8 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v10 = {
        "kind": "Variable",
        "name": "calendarId",
        "variableName": "calendarId"
    } as any, v11 = {
        "kind": "Variable",
        "name": "calendarIds",
        "variableName": "calendarIds"
    } as any, v12 = {
        "kind": "Variable",
        "name": "rangeMax",
        "variableName": "rangeMax"
    } as any, v13 = {
        "kind": "Variable",
        "name": "rangeMin",
        "variableName": "rangeMin"
    } as any, v14 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v15 = {
        "kind": "Variable",
        "name": "week",
        "variableName": "week"
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v18 = [
        (v10 /*: any*/),
        (v12 /*: any*/),
        (v13 /*: any*/),
        (v14 /*: any*/)
    ], v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focusMinutes",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "busyMinutes",
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalMinutes",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v24 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amBits",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pmBits",
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                (v6 /*: any*/),
                (v7 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "CalendarProfileRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v8 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v9 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v13 /*: any*/),
                                        {
                                            "kind": "Variable",
                                            "name": "showWeekInReview",
                                            "variableName": "showWeekInReview"
                                        },
                                        (v14 /*: any*/),
                                        (v15 /*: any*/)
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "CalendarProfile_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v6 /*: any*/),
                (v4 /*: any*/),
                (v3 /*: any*/),
                (v5 /*: any*/),
                (v7 /*: any*/)
            ],
            "kind": "Operation",
            "name": "CalendarProfileRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v8 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v16 /*: any*/),
                        (v9 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v11 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByCalendarIdsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Person",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v9 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "emails",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserProfile",
                                                            "kind": "LinkedField",
                                                            "name": "profile",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "givenName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "familyName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "externalImageUrl",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isYou",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isUser",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "userId",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "PersonList",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v17 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v18 /*: any*/),
                                    "concreteType": "CalendarTimeStats",
                                    "kind": "LinkedField",
                                    "name": "calendarTimeStats",
                                    "plural": false,
                                    "selections": [
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "fragmentedMinutes",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "unclassifiedMinutes",
                                            "storageKey": null
                                        },
                                        (v22 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CalendarFocusTimeScore",
                                            "kind": "LinkedField",
                                            "name": "scoresByDay",
                                            "plural": true,
                                            "selections": [
                                                (v19 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "secondaryKey",
                                                    "storageKey": null
                                                },
                                                (v21 /*: any*/),
                                                (v20 /*: any*/),
                                                (v22 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserWorkingHours",
                                    "kind": "LinkedField",
                                    "name": "userWorkingHours",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingHours",
                                            "kind": "LinkedField",
                                            "name": "workingHours",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DaySetting",
                                                    "kind": "LinkedField",
                                                    "name": "daySettings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "day",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v9 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v18 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "collaboratorStatsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v23 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v19 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CollaboratorScore",
                                                    "kind": "LinkedField",
                                                    "name": "topCollaborators",
                                                    "plural": true,
                                                    "selections": [
                                                        (v19 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "sharedMinutes",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "CollaboratorStats",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "condition": "showWeekInReview",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": [
                                                (v10 /*: any*/),
                                                (v15 /*: any*/)
                                            ],
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "rewindHistoryErrorable",
                                            "plural": false,
                                            "selections": [
                                                (v16 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v17 /*: any*/),
                                                        (v23 /*: any*/)
                                                    ],
                                                    "type": "GraphEntityError",
                                                    "abstractKey": null
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v9 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "snapshotDurationMillis",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CompactCalendarSlotSnapshot",
                                                            "kind": "LinkedField",
                                                            "name": "snapshots",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "snapshotMillis",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "DaySnapshot",
                                                                    "kind": "LinkedField",
                                                                    "name": "days",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SnapshotBits",
                                                                            "kind": "LinkedField",
                                                                            "name": "workingHours",
                                                                            "plural": false,
                                                                            "selections": (v24 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SnapshotBits",
                                                                            "kind": "LinkedField",
                                                                            "name": "meetings",
                                                                            "plural": false,
                                                                            "selections": (v24 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SnapshotBits",
                                                                            "kind": "LinkedField",
                                                                            "name": "focusTime",
                                                                            "plural": false,
                                                                            "selections": (v24 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SnapshotBits",
                                                                            "kind": "LinkedField",
                                                                            "name": "lunch",
                                                                            "plural": false,
                                                                            "selections": (v24 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SnapshotBits",
                                                                            "kind": "LinkedField",
                                                                            "name": "fragmented",
                                                                            "plural": false,
                                                                            "selections": (v24 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "RewindHistory",
                                                    "abstractKey": null
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v9 /*: any*/)
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "ab0ecb9f44996dee31b647361876a8e8",
            "id": null,
            "metadata": {},
            "name": "CalendarProfileRendererQuery",
            "operationKind": "query",
            "text": "query CalendarProfileRendererQuery(\n  $orgRelayId: ID!\n  $calendarId: String!\n  $calendarIds: [String]!\n  $timeZone: String!\n  $rangeMin: DayTimeSlotInput!\n  $rangeMax: DayTimeSlotInput!\n  $showWeekInReview: Boolean!\n  $week: String!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      ...CalendarProfile_org_3kPRlL\n    }\n  }\n}\n\nfragment CalendarProfile_org_3kPRlL on Org {\n  id\n  experiments\n  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        isUser\n        userId\n        ...WeekInReviewNotAvailable_person\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  ...ProfileTimeVisualizations_org_2vYicO\n  ...ProfileCollaborators_orgRefetch_3nh1j1\n  ...ProfileCollaborators_org_2vYicO\n  rewindHistoryErrorable(calendarId: $calendarId, week: $week) @include(if: $showWeekInReview) {\n    __typename\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on RewindHistory {\n      ...WeekInReviewScrubber_rewindHistory\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...WeekInReviewNotAvailable_org\n}\n\nfragment ProfileCollaborators_orgRefetch_3nh1j1 on Org {\n  id\n  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        primaryEmail\n        profile {\n          givenName\n          familyName\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment ProfileCollaborators_org_2vYicO on Org {\n  id\n  collaboratorStatsErrorable(calendarId: $calendarId, timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n    }\n    ... on CollaboratorStats {\n      calendarId\n      topCollaborators {\n        calendarId\n        sharedMinutes\n      }\n    }\n  }\n}\n\nfragment ProfileTimeVisualizations_org_2vYicO on Org {\n  calendarTimeStats(calendarId: $calendarId, timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax) {\n    calendarId\n    focusMinutes\n    busyMinutes\n    fragmentedMinutes\n    unclassifiedMinutes\n    totalMinutes\n    scoresByDay {\n      calendarId\n      secondaryKey\n      busyMinutes\n      focusMinutes\n      totalMinutes\n    }\n  }\n  userWorkingHours {\n    workingHours {\n      daySettings {\n        day\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment WeekInReviewNotAvailable_org on Org {\n  id\n}\n\nfragment WeekInReviewNotAvailable_person on Person {\n  id\n  emails\n  primaryEmail\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n  isYou\n  isUser\n  userId\n}\n\nfragment WeekInReviewScrubber_rewindHistory on RewindHistory {\n  id\n  snapshotDurationMillis\n  snapshots {\n    snapshotMillis\n    days {\n      workingHours {\n        amBits\n        pmBits\n      }\n      meetings {\n        amBits\n        pmBits\n      }\n      focusTime {\n        amBits\n        pmBits\n      }\n      lunch {\n        amBits\n        pmBits\n      }\n      fragmented {\n        amBits\n        pmBits\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'f9ef3cbb3f88a53c138b563b31df9d96';
export default node;
